module.exports = __webpack_public_path__ + "img/remove.1931883e.svg";